module.exports = __webpack_public_path__ + "static/media/about-bg-1-sm.40b53774.png";